import { render, staticRenderFns } from "./VariationsProduct.vue?vue&type=template&id=aa0b6b54&scoped=true&"
import script from "./VariationsProduct.vue?vue&type=script&lang=js&"
export * from "./VariationsProduct.vue?vue&type=script&lang=js&"
import style0 from "./VariationsProduct.vue?vue&type=style&index=0&id=aa0b6b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0b6b54",
  null
  
)

export default component.exports